import React from 'react'

import PropTypes from 'prop-types'

import './TextInput.less'

import MessageText from '../MessageText'

import classNames from 'classnames'

class TextInput extends React.Component {
  handleChange = (e) => {
    if (this.props.onChange && this.props.enabled) {
      this.props.onChange(e.target.value)
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (this.props.onEnterPressed) {
        this.props.onEnterPressed()
      }
    }
  }

  render () {
    let classesObject = {
      'nmc-input-text': true,
      'is-disabled': !this.props.enabled,
      'nmc-input-error': !!this.props.errorText
    }

    if (this.props.className) {
      classesObject[ this.props.className ] = true
    }

    return (
      <div className='nmc-input-container'>
        <input placeholder={this.props.placeholder} type='text' value={this.props.value} onKeyPress={this.handleKeyPress} onChange={this.handleChange} className={classNames(classesObject)} />
        {this.props.errorText && <div className='nmc-input-error-image' />}
        {(this.props.errorText || this.props.successText) && <MessageText small isSuccess={!!this.props.successText}>{this.props.errorText || this.props.successText}</MessageText>}
      </div>
    )
  }
}

TextInput.defaultProps = {
  value: '',
  errorText: '',
  enabled: true
}

TextInput.propTypes = {
  onChange: PropTypes.func,
  onEnterPressed: PropTypes.func,
  errorText: (props, propName, componentName) => {
    const baseError = 'Invalid prop `' + propName + '` supplied to' +
      ' `' + componentName + '`. Validation failed '
    if (props.successText && props.errorText) {
      return new Error(baseError + 'Can not have both error and success messages')
    } else if (!(typeof props.errorText === 'string')) {
      return new Error(baseError + 'Should be a string but got ' + typeof props.errorText)
    }
    return null
  },
  successText: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  enabled: PropTypes.bool
}

export default TextInput



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/TextInput/index.js